"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MuiStepperOverrides = {
    MuiStepIcon: {
        styleOverrides: {
            root: ({ ownerState }) => ({
                color: ownerState.active || ownerState.completed
                    ? undefined
                    : '#BBBBBB',
            }),
        },
    },
    MuiStepLabel: {
        styleOverrides: {
            root: {
                paddingLeft: 8,
            },
            label: {
                fontWeight: 600,
                fontSize: 14,
                marginRight: 10,
                marginLeft: 6,
                '&.Mui-completed': {
                    fontWeight: 600,
                    color: '#333333',
                },
                '&.Mui-active': {
                    fontWeight: 600,
                    color: '#333333',
                },
                '&.Mui-disabled': {
                    fontWeight: 600,
                    color: '#666666',
                },
            },
        },
    },
    MuiStepConnector: {
        styleOverrides: {
            line: {
                borderColor: '#CCCCCC',
                top: 'calc(50% + 12px)',
            },
        },
    },
};
exports.default = MuiStepperOverrides;
//# sourceMappingURL=MuiStepperOverrides.js.map